import {crud} from 'app/lib/action';
import {SUBMIT_VISIT} from '../constants/actionTypes';

export default crud(SUBMIT_VISIT);